package com.qrkontaq.ui.theme

import com.varabyte.kobweb.compose.ui.graphics.Color

/**
 * QRkontaq design tokens (see design-prompts/): platform brand for landing/admin,
 * warm neutral surface palette for tenant menu sites. A restaurant's own accent color
 * (from its profile) always wins on the tenant site.
 */
object Brand {
    // Platform
    val Emerald = Color.hex("0F9D6E")
    val EmeraldDark = Color.hex("0B7A55")
    val Coral = Color.hex("FF6B5B")

    // Neutral warm surfaces (tenant menu default theme)
    val WarmBackground = Color.hex("FAF8F5")
    val Surface = Color.hex("FFFFFF")
    val Charcoal = Color.hex("1F2421")
    val TextSecondary = Color.hex("6B7280")
    val Divider = Color.hex("ECE8E2")
    val UnavailableOverlay = Color.hexa("FAF8F5", 0.6f)

    // Semantic accents for the tenant menu
    val Amber = Color.hex("E8A33D")
    val Green = Color.hex("2E9E5B")
    val CoralText = Color.hex("E05B4C")
    val OpenDot = Color.hex("4ADE80")
    val ClosedDot = Color.hex("FF8A7A")
    /** Light mint used for accents on the dark admin sidebar. */
    val MintOnDark = Color.hex("7EE2BC")
    val GreenSoft = Color.hexa("2E9E5B", 0.12f)
    val CoralSoft = Color.hexa("FF6B5B", 0.12f)

    /** Default tenant accent when the restaurant has not picked one. */
    const val DefaultAccentHex = "#C4573A"
    val DefaultAccent = Color.hex("C4573A")

    const val RadiusCard = 16
    const val RadiusChip = 999
    const val RadiusSheet = 24

    private val HexColor = Regex("^#[0-9a-fA-F]{6}$")

    fun accentFrom(hex: String?): Color =
        hex?.takeIf { it.matches(HexColor) }
            ?.let { Color.hex(it) }
            ?: DefaultAccent

    /** Same accent as [accentFrom] but as a raw CSS hex string (for CSS variables). */
    fun accentHexFrom(hex: String?): String =
        hex?.takeIf { it.matches(HexColor) } ?: DefaultAccentHex
}
